import React from 'react'
import { Routes, Route } from 'react-router-dom'
import Mapping from './Pages/Mapping'
import ErrorBoundary from './Component/ErrorBoundary'

function App() {
  return (
    <ErrorBoundary>
      <Routes>
        <Route path='/:Id' element={<Mapping />} />
        <Route path='*' element={<div className="map_error">No venture id in the URL.</div>} />
      </Routes>
    </ErrorBoundary>
  )
}

export default App
